import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

import { focusRingWithin } from '../styles/focus-ring';

export const wrapperVariants = cva(
  cn(
    'flex items-center rounded-md border border-solid border-border bg-surface',
    focusRingWithin
  ),
  {
    variants: {
      density: {
        // `rounded-lg` overrides the base `rounded-md` (deduped by tailwind-merge).
        comfortable: 'h-fit gap-2 rounded-lg px-3',
        compact: 'h-7 gap-x-1 px-2.5',
      },
    },
    defaultVariants: {
      density: 'comfortable',
    },
  }
);

// Disabled-state wrapper overrides:
// - [&_svg]:text-text-disabled — pin accessory icons to disabled tint, ignoring consumer color.
// - [&_button_svg]:text-current — exempt button-internal icons so accessory buttons keep their own state.
export const wrapperDisabledClasses =
  'bg-surface-disabled text-text-disabled [&_svg]:text-text-disabled [&_button_svg]:text-current';

export const inputVariants = cva(
  'flex w-full truncate border-0 bg-transparent transition-colors file:bg-transparent file:font-medium placeholder:text-text-secondary focus-visible:outline-none disabled:cursor-not-allowed disabled:text-text-disabled disabled:placeholder:text-text-disabled',
  {
    variants: {
      density: {
        comfortable: 'h-[38px] text-sm file:text-sm',
        compact: 'h-full text-xs font-medium file:text-xs',
      },
    },
    defaultVariants: {
      density: 'comfortable',
    },
  }
);

export const inputAutofillClasses =
  '[&:-webkit-autofill]:!bg-surface [&:-webkit-autofill]:shadow-[0_0_0_30px_white_inset] newBrand:[&:-webkit-autofill]:shadow-none newBrandDark:[&:-webkit-autofill]:shadow-none';
